import { AppId, FCX, ProductLogo, usePlatformContext } from "@datassential/platform-ui-lib";
import { useMemo } from "react";
import { sanitizeUrl } from "@helpers";
import './ExternalProductLink.scss';

const FoodExternalProductLink: FCX<{
    appId: AppId;
    path?: string;
    link?: string;
}> = ({
    appId,
    path,
    link,
    testId
}) => {
    const { userInfo: { products} } = usePlatformContext();

    const product = useMemo(
        () => products[appId],
        [products, appId]
    );

    if (product.isDisabled) return null;

    return (
        <a
            href={link ?? sanitizeUrl(`${product.url}${path}`)}
            target="_blank"
            rel="noreferrer"
            className="FoodExternalProductLink"
            data-testid={testId}
        >
            go to
            <ProductLogo
                appId={appId}
                type="regular"
                className="FoodExternalProductLink__icon"
            />
        </a>
    );
};

export default FoodExternalProductLink;